import { styled } from '@linaria/react';
import { fonts, semantic, space } from '../../theme/tokens';

export const Pill = styled.button`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.semiBold};
  padding: ${space['space-300']} ${space['space-400']};
  border-radius: 24px;
  border: none;
  background: ${semantic.bg.surfaceSubtle};
  color: ${semantic.text.primary};
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
  white-space: nowrap;

  &[data-selected='true'] {
    background: ${semantic.bg.primary};
    color: ${semantic.text.inverse};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &[data-variant='display'] {
    font-size: ${fonts.size.xs};
    font-weight: ${fonts.weight.normal};
    padding: ${space['space-200']} ${space['space-300']};
    border: none;
    background: ${semantic.bg.surfaceSubtle};
    color: ${semantic.text.primary};
    cursor: default;
  }
`;
